import React, { ReactElement, useState } from 'react'
import { DatePicker, HeaderPage, Input, Select } from '@components/atoms'
import { ContainerPesquisa } from '@pages/style'
import { useForm } from 'react-hook-form'
import { Button, Col, Row, Typography, Table, Spin, Drawer } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { SearchOutlined } from '@ant-design/icons'

const data = [
  {
    FILIAL: 'Filial 1',
    CONSIGNACAO: 'Consignação 1',
    CLIENTE: 'Cliente 1',
    VENDEDOR: 'Vendedor 1',
    DTCADASTRO: '01/01/2001',
    VLRCONSIGNACAO: 'R$ 935,00',
  },
  {
    FILIAL: 'Filial 2',
    CONSIGNACAO: 'Consignação 2',
    CLIENTE: 'Cliente 2',
    VENDEDOR: 'Vendedor 2',
    DTCADASTRO: '01/01/2002',
    VLRCONSIGNACAO: 'R$ 935,00',
  },
  {
    FILIAL: 'Filial 3',
    CONSIGNACAO: 'Consignação 3',
    CLIENTE: 'Cliente 3',
    VENDEDOR: 'Vendedor 3',
    DTCADASTRO: '01/01/2003',
    VLRCONSIGNACAO: 'R$ 935,00',
  },
  {
    FILIAL: 'Filial 4',
    CONSIGNACAO: 'Consignação 4',
    CLIENTE: 'Cliente 4',
    VENDEDOR: 'Vendedor 4',
    DTCADASTRO: '01/01/2004',
    VLRCONSIGNACAO: 'R$ 935,00',
  },
]

export default function VendasConsignadas(): ReactElement {
  const { control, watch, reset } = useForm()
  const { Option } = Select
  // const methods = useForm()
  const allFields = /* methods. */ watch()
  const { Column } = Table
  const [spinning, setSpinning] = useState(false)
  const [visible, setVisible] = useState(false)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const limparFiltros = () => {
    reset()
  }

  return (
    <ContainerPesquisa>
      <Content style={{ padding: 24 }}>
        <Spin tip='Filtrando...' spinning={spinning}>
          <HeaderPage
            title='Vendas Consignadas em Aberto'
            extra={[
              <Button
                key='buttonSearch'
                className='buttonSearch'
                onClick={() => showDrawer()}
              >
                <p>Filtrar</p>
                <SearchOutlined key='iconSearch' className='iconSearch' />
              </Button>,
            ]}
          />
          <Table dataSource={data}>
            <Column title='Filial' dataIndex={'FILIAL'} />
            <Column title='Consignação' dataIndex={'CONSIGNACAO'} />
            <Column title='Cliente' dataIndex={'CLIENTE'} />
            <Column title='Vendedor' dataIndex={'VENDEDOR'} />
            <Column title='Data Cadastro' dataIndex={'DTCADASTRO'} />
            <Column title='Valor Consignação' dataIndex={'VLRCONSIGNACAO'} />
          </Table>
        </Spin>
      </Content>
      <Drawer
        onClose={onClose}
        visible={visible}
        title='Filtros'
        style={{ marginTop: '4rem' }}
      >
        <Row key='mainRow'>
          <Col span={24}>
            <Typography.Title level={5}>Nr. Consignado</Typography.Title>
            <Input
              control={control}
              name='NUMEROCONSIGNADO'
              placeholder='Nr. Consignado'
            />
          </Col>
          <Col span={allFields.CLIENTE === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Cliente</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='CLIENTE'
              placeholder='Cliente'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.CLIENTE === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Cliente Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='CLIENTEESPEC'
                placeholder='Cliente Específico'
              >
                <Option value='Cliente 1'>Cliente 1</Option>
                <Option value='Cliente 2'>Cliente 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.VENDEDOR === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Vendedor</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='VENDEDOR'
              placeholder='Vendedor'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.VENDEDOR === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Vendedor Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='VENDEDORESPEC'
                placeholder='Vendedor Específico'
              >
                <Option value='Vendedor 1'>Vendedor 1</Option>
                <Option value='Vendedor 2'>Vendedor 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.TERMINAL === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Terminal</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='TERMINAL'
              placeholder='Terminal'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.TERMINAL === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Terminal Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='TERMINALESPEC'
                placeholder='Terminal Específico'
              >
                <Option value='Terminal 1'>Terminal 1</Option>
                <Option value='Terminal 2'>Terminal 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={24}>
            <Typography.Title level={5}>Origem</Typography.Title>
            <Select
              control={control}
              allowClear
              name='ORIGEM'
              placeholder='Origem'
            >
              <Option value='Assistência'>Assistência</Option>
              <Option value='Vendas'>Vendas</Option>
              <Option value='Ambos'>Ambos</Option>
            </Select>
          </Col>
          <Col span={24}>
            <Typography.Title level={5}>Período de Cadastro</Typography.Title>
            <Row gutter={3} align='middle'>
              <Col span={12}>
                <DatePicker name='DTINICIO' control={control} />
              </Col>
              <Col span={12}>
                <DatePicker name='DTFINAL' control={control} />
              </Col>
            </Row>
          </Col>
          <Col span={24} style={{ marginTop: '1.5rem' }}>
            <Row gutter={5}>
              <Col>
                <Button
                  danger
                  type='default'
                  onClick={() => {
                    limparFiltros()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Limpar filtro
                </Button>
              </Col>
              <Col>
                <Button
                  type='primary'
                  onClick={() => {
                    onClose()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Filtrar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    </ContainerPesquisa>
  )
}
